var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDate = function SvgDate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h16v16H-1z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#777776",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.333 3.333A.667.667 0 0 0 1.667 4v9.333c0 .369.298.667.666.667h9.334a.667.667 0 0 0 .666-.667V4a.667.667 0 0 0-.666-.667H2.333zm0-1.333h9.334a2 2 0 0 1 2 2v9.333a2 2 0 0 1-2 2H2.333a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.333A.667.667 0 0 1 1 6h12a.667.667 0 0 1 0 1.333H1zM9 1.333a.667.667 0 1 1 1.333 0V4A.667.667 0 1 1 9 4V1.333zM3.667 1.333a.667.667 0 0 1 1.333 0V4a.667.667 0 0 1-1.333 0V1.333z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date.0ec10963.svg";
export { ForwardRef as ReactComponent };